module.exports = __webpack_public_path__ + "img/homepage-interest-pink.f0a81af3.svg";